import { ACOMPANHAMENTO_TERRITORIO_PATH } from 'components/layout/SideMenu/SideMenuItems'

export const CADASTRAR_IMOVEL_PATH = `${ACOMPANHAMENTO_TERRITORIO_PATH}/cadastrarImovel`

export const EDITAR_IMOVEL_PATH = `${ACOMPANHAMENTO_TERRITORIO_PATH}/editarImovel`

export const MENSAGEM_TOOLTIP_FAMILIA_MUDOUSE = 'Cidadãos não podem ser adicionados em uma família que se mudou.'

export const MENSAGEM_TOOLTIP_FAMILIA_INATIVA = 'Não é possível editar famílias em um imóvel inativado.'
